{
  "tiers": [
    {
      "name": "Enterprise",
      "range": "Revenue over $1 billion",
      "advisors": [
        { "name": "Teresa White", "role": "former President, Aflac US" },
        { "name": "Keith Banks", "role": "former Vice Chair, Bank of America" },
        { "name": "Andrew Robertson", "role": "Chairman, BBDO Worldwide" },
        { "name": "Catherine Keating", "role": "former CEO USA, BNY Mellon" },
        { "name": "Cindy Baier", "role": "former CEO, Brookdale Senior Living" },
        { "name": "Doug Conant", "role": "former CEO, Campbell Soup Company" },
        { "name": "Charlie Lanktree", "role": "former CEO, Eggland’s Best" },
        { "name": "Ravi Saligram", "role": "former CEO, Newell Brands" },
        { "name": "Mike Critelli", "role": "former CEO and Chairman, Pitney Bowes" },
        { "name": "Caroline Feeney", "role": "former CEO, U.S. Insurance and Retirement, Prudential" },
        { "name": "Adam Goldstein", "role": "former CEO, Royal Caribbean International" },
        { "name": "Dan Hesse", "role": "former CEO, Sprint" },
        { "name": "Brian Gallagher", "role": "former Global CEO, United Way" },
        { "name": "David Sable", "role": "Vice Chairman Stagwell, and former CEO, Young & Rubicam" }
      ]
    },
    {
      "name": "Operators",
      "range": "Revenue between $100 million and $1 billion",
      "advisors": [
        { "name": "Brian Scudamore", "role": "founder and CEO, 1-800-GOT-JUNK?" },
        { "name": "Rick Rosenfield", "role": "founding Co-CEO, California Pizza Kitchen" },
        { "name": "Dottie Herman", "role": "Vice Chair and former CEO, Douglas Elliman" },
        { "name": "Farooq Kathwari", "role": "CEO, Chairman, President, Ethan Allen" },
        { "name": "Jack Mitchell", "role": "former CEO, The Mitchell Family of Stores" },
        { "name": "Michael Chen", "role": "former Divisional CEO, GE Capital and NBC Universal" },
        { "name": "Chris Artinian", "role": "former CEO, Morton’s Steakhouse" },
        { "name": "Nate Rempe", "role": "CEO, Omaha Steaks" },
        { "name": "Jamie O’Rourke", "role": "former CEO, Sperry Rail" }
      ]
    },
    {
      "name": "Entrepreneurs",
      "range": "Revenue between $10 million and $100 million",
      "advisors": [
        { "name": "Michael Houlihan", "role": "founding CEO, Barefoot Wine" },
        { "name": "Joseph Hansen", "role": "founding CEO, Buy Box Experts" },
        { "name": "Adam von Gootkin", "role": "founder and CEO, Highclere Castle Spirits" },
        { "name": "Colleen Joyce", "role": "co-founder & CEO, Lawyer.com" },
        { "name": "Lee Mandel", "role": "founder & CEO, XSponse" }
      ]
    }
  ]
}
